function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

window.addEventListener("scroll", function () {
  let add_to_cart_btn = document.querySelector(".add-to-cart");
  let sticky_add_to_cart_btn = document.querySelector(".product-sticky-bar");

  if (add_to_cart_btn) {
    if (isInViewport(add_to_cart_btn)) {
      sticky_add_to_cart_btn.classList.remove("active");
    } else {
      sticky_add_to_cart_btn.classList.add("active");
    }
  }
});

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        document
          .querySelector(".add-to-cart-sticky")
          .addEventListener("click", () => {
            document.querySelector(".add-to-cart").click();
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("disabled") === "disabled") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("disabled", true);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.removeAttribute("disabled");
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (!this.error) this.submitButton.removeAttribute("disabled");
            window.dispatchEvent(new CustomEvent("cart:updated"));
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

window.addEventListener("load", () => {
  let price_button_hide = document.querySelector(".hide-price");
  let price_button_show = document.querySelector(".show-price");
  if (price_button_hide) {
    price_button_hide.addEventListener("click", (e) => {
      e.preventDefault();
      price_button_hide.classList.add("hidden");
      price_button_show.classList.remove("hidden");
      document.querySelector(".price__container").classList.add("hidden");
    });
  }
  if (price_button_show) {
    price_button_show.addEventListener("click", (e) => {
      e.preventDefault();
      price_button_show.classList.add("hidden");
      price_button_hide.classList.remove("hidden");
      document.querySelector(".price__container").classList.remove("hidden");
    });
  }

  let show_description_button = document.querySelector(
    ".product-form-description__show"
  );
  let hide_description_button = document.querySelector(
    ".product-form-description__hide"
  );
  let short_description = document.querySelector(
    ".product-form-short-description"
  );
  let full_description = document.querySelector(
    ".product-form-main-description"
  );

  if (show_description_button) {
    show_description_button.addEventListener("click", (e) => {
      e.preventDefault();
      show_description_button.classList.add("hidden");
      hide_description_button.classList.remove("hidden");
      short_description.classList.add("hidden");
      full_description.classList.remove("hidden");
      toggleAlignBottom();
    });
  }
  if (hide_description_button) {
    hide_description_button.addEventListener("click", (e) => {
      e.preventDefault();
      hide_description_button.classList.add("hidden");
      show_description_button.classList.remove("hidden");
      short_description.classList.remove("hidden");
      full_description.classList.add("hidden");
      toggleAlignBottom();
    });
  }
});

class PopinProduct extends HTMLElement {
  constructor() {
    super();
    let openBtn = document.querySelector(
      `[data-open-popin="${this.dataset.popinId}"]`
    );
    let body = document.querySelector("body");
    let closBtn = this.querySelector(".popin__close");

    // click outside to close

    body.addEventListener("click", (e) => {
      if (e.target === body) {
        body.classList.remove("shadow-popin");
        this.classList.remove("open");
      }
    });

    // close btn

    if (closBtn) {
      closBtn.addEventListener("click", (e) => {
        e.preventDefault();
        body.classList.remove("shadow-popin");
        this.classList.remove("open");
      });
    }

    if (openBtn) {
      openBtn.addEventListener("click", (e) => {
        e.preventDefault();
        body.classList.add("shadow-popin");
        this.classList.add("open");
      });
    }
  }
}

class ProductDescriptionExpand extends HTMLElement {
  constructor() {
    super();

    this.updateDescription(this.querySelector('.product-form-main-description'));
  }

  updateDescription = (description) => {
    const max_height = 80;
    const descriptionHeight = description.offsetHeight;

    if (descriptionHeight > max_height) {
      this.getMaxWords(description, max_height);
    }
  };

  getMaxWords = (description, max_height) => {
    let descriptionText = "";

    if (description.querySelector("[data-expand]")) {
      description.querySelector("[data-expand]").remove();
    }

    if (description.querySelectorAll("button").length > 0) {
      description.querySelectorAll(".reduce").forEach((button) => {
        button.remove();
      });
    }

    const descriptionTextArray = description.innerHTML.replaceAll('</span>', ' </span>').replaceAll('\n', ' \n').replaceAll('"', '@@').split(" ");
    console.log(descriptionTextArray);

    for (let i = 0; i < descriptionTextArray.length; i++) {
      description.innerHTML;
      descriptionText += descriptionTextArray[i] + " ";
      description.innerHTML = descriptionText;
      if (description.offsetHeight > max_height) {
        description.innerHTML =
          descriptionTextArray.slice(0, i).join(" ") +
          `<span style="display: none" data-expand="${descriptionTextArray
            .slice(i, descriptionTextArray.length)
            .join(" ")}"></span>`;
        description.innerHTML = description.innerHTML;
        console.log(description, description.innerHTML);
        description.innerHTML =
          description.innerHTML +
          `<button class="see-more small-text">> Lire toute la description</button>`;
        description
          .querySelector(".see-more")
          .addEventListener("click", (e) => {
            this.expandDescription(description, e);
          });
        break;
      }
    }
  };

  expandDescription = (description, e) => {
    if (description.querySelector("[data-expand]")) {
      const descriptionText = description
        .querySelector("[data-expand]")
        .getAttribute("data-expand");

      description.innerHTML += " " + descriptionText.replaceAll('@@', '"');
      description.querySelector("[data-expand]").remove();
      description.querySelector(".see-more").remove();
      description.innerHTML += `<button class="reduce small-text">< Réduire la description</button>`;
      description.querySelector(".reduce").addEventListener("click", () => {
        this.updateDescription(description);
      });
    }
  };

  removeExpandDescription() {
    this.querySelectorAll(".pictos-text__picto p").forEach((p) => {
      this.expandDescription(p);
      if (p.querySelector("[data-expand]")) {
        p.querySelector("[data-expand]").remove();
      }

      if (p.querySelectorAll("button").length > 0) {
        p.querySelectorAll("button").forEach((button) => {
          button.remove();
        });
      }
    });
  }
}

customElements.define("product-description", ProductDescriptionExpand);

customElements.define("popin-product", PopinProduct);

document.addEventListener("DOMContentLoaded", () => {
  let current_select = document.querySelector(
    ".select-variants .select__select"
  );
  let selectVariant = document.querySelector(".select-variants");

  let select = document.querySelector(".select-values");
  let select_items = document.querySelectorAll(".select-values label");
  if (current_select) {
    current_select.addEventListener("click", () => {
      select.classList.toggle("open");
      selectVariant.classList.toggle("opened");
    });

    select_items.forEach((item) => {
      item.addEventListener("click", (e) => {
        select.classList.remove("open");
        selectVariant.classList.remove("opened");
        const _for = e.currentTarget.getAttribute("for");
        const _input = document.querySelector(`select[name="${_for}"]`);

        select_items.forEach((item) => {
          item.classList.remove("actif");
        });

        if (_input) {
          e.currentTarget.classList.add("actif");
          _input.value = e.currentTarget.getAttribute("value");
          _input.dispatchEvent(new Event("change"));
          _input.closest("variant-selects").dispatchEvent(new Event("change"));
          current_select.querySelector("label").innerHTML =
            e.currentTarget.innerHTML;
        }
      });
    });
  }

  // check if click outside select and close it
  document.addEventListener("click", (e) => {
    if (e.target.closest(".select-variants")) return;
    select ? select.classList.remove("open") : null;
    selectVariant ? selectVariant.classList.remove("opened") : null;
  });

  initSwiperVariantCollections();
});

function initSwiperVariantCollections() {
  let swiperVariantCollections = document.querySelector(
    ".swiper--variant-collections .swiper"
  );
  if (swiperVariantCollections) {
    let swiper = new Swiper(swiperVariantCollections, {
      slidesPerView: "auto",
      spaceBetween: 8,
      loop: false,
      a11y: false,
      navigation: {
        nextEl: document.querySelector(
          ".swiper-button-next--variant-collections"
        ),
        prevEl: document.querySelector(
          ".swiper-button-prev--variant-collections"
        ),
      },
      breakpoints: {
        768: {},
        1024: {},
      },
    });

    let current_index = swiperVariantCollections.querySelector(".actif");
    if (current_index) {
      swiper.slideTo(current_index.dataset.index);
    }
  }
}
